import type { TravelerInformation as ApiTravelerInformation } from '@/shared/types/api.types'
import { TravelDirection } from '@/shared/types/common.types'
import { parseDateFromStr } from '@/shared/utils'
import type { TravelerOption } from '@/shared/composables/useGerInsuredTravelersOptions'

const getOutboundInformation = (traveler: ApiTravelerInformation) => ({
  withWinterSport: !!traveler.winSports,
})

const getGeneralInformation = (traveler: ApiTravelerInformation): TravelerOption => ({
  srNo: String(traveler.srNo),
  dateOfBirth: parseDateFromStr(traveler.dateOfBirth),
  nationalityName: traveler.nationalityName,
  passportNo: traveler.passportNo,
  relationName: (() => {
    const relation = traveler.relationName
    const firstLetter = relation.charAt(0)
    const restWord = relation.slice(1).toLowerCase()
    return `${firstLetter}${restWord}`
  })(),
})

export const getTravelersInformation = (
  travelers: ApiTravelerInformation[],
  withWinterSport: boolean,
  typeOfTravel: TravelDirection = TravelDirection.OUTBOUND
): { information: TravelerOption; name: string; id: string }[] =>
  travelers.map((traveler) => {
    const winterSportInformation = withWinterSport ? getOutboundInformation(traveler) : {}
    return {
      name: `${traveler.firstName} ${traveler.lastName}`,
      id: String(traveler.srNo),
      information:
        typeOfTravel === TravelDirection.OUTBOUND
          ? {
              ...getGeneralInformation(traveler),
              ...winterSportInformation,
            }
          : getGeneralInformation(traveler),
    }
  })
